'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

NewPasswordValidatorsDirective=class NewPasswordValidatorsDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['newPassword'];
}

get templateUrl(){
return'/templates/directives/newPasswordValidatorsDirective/newPasswordValidatorsTemplate';
}

get controller(){
return NewPasswordValidatorsDirectiveController;
}};let


NewPasswordValidatorsDirectiveController=class NewPasswordValidatorsDirectiveController{
static get $inject(){
return[];
}

constructor(){
this._validators=[{
label:'2 Letters',
isValid:()=>_.exists(this.newPassword)&&_.exists(this.newPassword.match(/[a-z].*[a-z]/i))},
{
label:'2 Numbers',
isValid:()=>_.exists(this.newPassword)&&_.exists(this.newPassword.match(/[0-9].*[0-9]/))},
{
label:'8 Character Minimum',
isValid:()=>_.exists(this.newPassword)&&this.newPassword.length>=8}];

}

get validators(){
return this._validators;
}};



module.exports=NewPasswordValidatorsDirective;
//# sourceMappingURL=newPasswordValidatorsDirective.js.map
